import { PrinterOutlined } from "@ant-design/icons";
import { message } from "antd";

import { buildApiUrl, fetchApi } from "@neu/libui";
import type { EntityFormConfig, FormActionButtonsContext } from "@neu/libui";

async function openPlanInvoicePdf(entityID: string | number): Promise<void> {
	const url = buildApiUrl(`/pdf/print/plan-invoice?id=${String(entityID)}`);
	const result = await fetchApi(url, { parseAs: "blob" });
	const objectURL = URL.createObjectURL(result.blob);
	window.open(objectURL, "_blank");
}

export const plan_invoice: EntityFormConfig = {
	actionButtons: (ctx: FormActionButtonsContext) => ({
		print: {
			onClick: async () => {
				if (ctx.entityID === null) return;
				try {
					await openPlanInvoicePdf(ctx.entityID);
				} catch (err: unknown) {
					message.error(
						err instanceof Error ? err.message : "Print failed"
					);
				}
			},
			isVisible: () => ctx.entityID !== null,
			icon: <PrinterOutlined />,
			label: "Print",
			position: "center",
			type: "secondary",
		},
	}),
};
